import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, withRouter, Redirect } from 'react-router-dom';
import { ScrollToTop } from '@youngcapital/component-library';
import Page from './components/Page';
import Blokkendoos from './services/blokkendoos';
import config from './config';

import { AppContextProvider } from './AppContext';
import withIsolation from './components/helpers/withIsolation';
import { SIGNUP_FOR_MAPPING } from './services/constants';

const locationPath = window.location.pathname;

const ScrollToTopComponent = ScrollToTop(withRouter);

function App(props) {
  const blokkendoos = new Blokkendoos();
  const signupFor = props.signupFor || blokkendoos.getSignupFor();
  const siteAbbr = blokkendoos.getSiteAbbr();
  const { pages } = props.cfg || config(signupFor, siteAbbr);
  const routes = pages.map((_, index) => {
    if (index === 0) return '/';
    return `/page/${index}`;
  });
  const [values, setValues] = useState({});

  return (
    <BrowserRouter basename={locationPath}>
      <ScrollToTopComponent>
        {routes.map((path, index) => (
          <Route
            key={`${signupFor}_${index}`}
            exact
            path={path}
            render={() => (
              <AppContextProvider
                value={{
                  currentPageIndex: index,
                  pageConfig: pages[index],
                  pages,
                  path,
                  blokkendoos,
                  siteAbbr,
                  signupFor
                }}
              >
                <Page
                  routes={routes}
                  setValues={setValues}
                  values={values}
                  signupFor={signupFor}
                />
              </AppContextProvider>
            )}
          />
        ))}
        {/* This route is a workaround to feature flag behaviour.
        Basically when you it match for the old one, it'll be add /page/0
        in the URL. If you reload the page (e.g. by pressing F5) and you match the new SPA,
        /page/0 does not exist inside our SPA it wont render anything.
        */}
        <Route
          render={({ location }) => {
            if (location.pathname.includes('page/0')) {
              return <Redirect exact to='/' />;
            }
            return null;
          }}
        />
      </ScrollToTopComponent>
    </BrowserRouter>
  );
}

App.propTypes = {
  signupFor: PropTypes.oneOf(Object.keys(SIGNUP_FOR_MAPPING)).isRequired,
  cfg: PropTypes.object
};

export default withIsolation(App);
